import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { StrictMode } from "react";

// Providers
import Providers from "contexts";

// Styles
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.scss";
import "./index.css";
import "./design-system/styles";

// App
import App from "./App";
import { preloadPage } from "components/layout/MainContent/pageLoaders";
import { installChunkReload } from "services/chunkReload";
import { getConfig } from "services/configService";
import { migrateLegacyStorage } from "services/originMigration";
import { pageOf, parsePageParams } from "contexts/pageParams";

// A stale tab whose chunks were rotated by a deploy reloads itself once.
installChunkReload(window);
// Fetch the deep-linked page chunk while auth boots, not after it.
preloadPage(pageOf(parsePageParams(window.location.search)));
// First visit on this origin: carry over preferences from the previous host.
migrateLegacyStorage(getConfig().legacy_origin);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container not found");
}
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </StrictMode>
);
